import { defineMessages } from 'react-intl';

const messages = defineMessages({
  initiateBookingError: 'An error occurred while attempting to create a new booking.',
  noBookingPermissions: 'You do not have the correct permissions to view this booking.',
  missingRoomRates: 'Missing or inactive rates for one or more rooms. Please contact IT support.',
  insufficientBookingPermissions:
    'You do not have the correct permissions to view this stage of the booking flow. Ensure all prior steps have been completed. If this seems incorrect, please contact an Organization Admin.',
  // Payment
  paymentCodeLabel: 'Payment ID : {code} - {organizationName}',
  creditCardLabel: 'Credit Card : {cardNickName} (XXXX-XXXX-XXXX-{lastFourDigits})',
  paymentDisclaimerLink: 'View cancellation policy',
  paymentDisclaimerPending:
    "* Once your reservation is confirmed, you'll only be charged for the rooms you use, unless you fail to contact the lodge/hotel within its specified cancellation period.",
  paymentDisclaimerEditing:
    "* Once your reservation edits are confirmed, you'll only be charged for the rooms you use, unless you fail to contact the lodge/hotel within its specified cancellation period.",
  paymentDisclaimerConfirmed:
    "* Your reservation is confirmed!  You'll only be charged for the rooms you use, unless you fail to contact the lodge/hotel within its specified cancellation period.",
  paymentDisclaimerInProgress:
    "* Your reservation is in progress!  You'll only be charged for the rooms you use, unless you fail to contact the lodge/hotel within its specified cancellation period.",
  paymentDisclaimerCancelled:
    "* Your reservation has been cancelled.  You'll only be charged for the rooms you failed to cancel within the specified cancellation period of the lodge/hotel.",
  paymentDisclaimerExpired:
    "* Your reservation has expired.  You'll only be charged for the rooms you failed to cancel within the specified cancellation period of the lodge/hotel.",
  paymentDisclaimerComplete:
    "* Your reservation is complete!  You'll only be charged for the rooms you used, unless you failed to contact the lodge/hotel within its specified cancellation period.",
  getBookingStatusError: 'Unable to retrieve Booking Status'
});

export default messages;
